/* Kandlelicious "Glow" theme — functional JS layer. Vanilla JS, no dependencies. */
(function () {
  "use strict";

  var moneyFormat = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : "${{amount}}";

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Mobile nav ---------------- */
  var mobileNav = qs("[data-mobile-nav]");
  var mobileNavOverlay = qs("[data-mobile-nav-overlay]");
  var mobileNavToggle = qs("[data-mobile-nav-toggle]");
  var mobileNavClose = qs("[data-mobile-nav-close]");

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.hidden = false;
    mobileNavOverlay.hidden = false;
    requestAnimationFrame(function () {
      mobileNav.classList.add("active");
      mobileNavOverlay.classList.add("active");
    });
    document.documentElement.style.overflow = "hidden";
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove("active");
    mobileNavOverlay.classList.remove("active");
    document.documentElement.style.overflow = "";
    setTimeout(function () {
      mobileNav.hidden = true;
      mobileNavOverlay.hidden = true;
    }, 300);
  }
  if (mobileNavToggle) mobileNavToggle.addEventListener("click", openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener("click", closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener("click", closeMobileNav);

  /* ---------------- Search panel ---------------- */
  var searchToggle = qs("[data-search-toggle]");
  var searchPanel = qs("[data-search-panel]");
  var searchClose = qs("[data-search-close]");
  var searchInput = qs("[data-search-input]");

  function toggleSearch() {
    if (!searchPanel) return;
    var isHidden = searchPanel.hidden;
    searchPanel.hidden = !isHidden ? true : false;
    if (isHidden && searchInput) setTimeout(function () { searchInput.focus(); }, 50);
  }
  if (searchToggle) searchToggle.addEventListener("click", toggleSearch);
  if (searchClose) searchClose.addEventListener("click", function () { searchPanel.hidden = true; });

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = qs("[data-cart-drawer]");
  var cartOverlay = qs("[data-cart-overlay]");
  var cartDrawerBody = qs("[data-cart-drawer-body]");
  var cartCountEls = qsa("[data-cart-count]");
  var cartBar = qs("#kwx-cart-bar");
  var cartBarMsg = cartBar ? cartBar.querySelector(".kwx-cart-bar-msg") : null;

  function openCartDrawer() {
    if (!cartDrawer) { window.location.href = "/cart"; return; }
    cartDrawer.hidden = false;
    cartOverlay.hidden = false;
    requestAnimationFrame(function () {
      cartDrawer.classList.add("active");
      cartOverlay.classList.add("active");
    });
    document.documentElement.style.overflow = "hidden";
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("active");
    cartOverlay.classList.remove("active");
    document.documentElement.style.overflow = "";
    setTimeout(function () {
      cartDrawer.hidden = true;
      cartOverlay.hidden = true;
    }, 300);
  }
  qsa("[data-cart-drawer-toggle]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      refreshCartDrawer().then(openCartDrawer);
    });
  });
  qsa("[data-cart-drawer-close]").forEach(function (el) { el.addEventListener("click", closeCartDrawer); });
  if (cartOverlay) cartOverlay.addEventListener("click", closeCartDrawer);

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function cartLineHtml(item) {
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, "_120x120$1$2") + '" alt="' + (item.product_title || "").replace(/"/g, "&quot;") + '" loading="lazy">' : "";
    var variant = item.variant_title ? '<p class="variant">' + item.variant_title + '</p>' : "";
    return (
      '<div class="kwx-cart-line" data-cart-line="' + item.key + '">' +
      img +
      '<div>' +
      '<h3><a href="' + item.url + '">' + item.product_title + '</a></h3>' +
      variant +
      '<div class="kwx-qty" data-qty-wrap>' +
      '<button type="button" data-qty-decrease aria-label="Decrease quantity">&minus;</button>' +
      '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qty-input readonly>' +
      '<button type="button" data-qty-increase aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<a href="#" class="kwx-cart-line-remove" data-cart-remove>Remove</a>' +
      '</div>' +
      '<div class="price">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>'
    );
  }

  function refreshCartDrawer() {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (!cartDrawerBody) return cart;
        if (cart.item_count === 0) {
          cartDrawerBody.innerHTML = '<div class="kwx-cart-empty"><p>Your cart is empty.</p></div>';
        } else {
          cartDrawerBody.innerHTML = cart.items.map(cartLineHtml).join("");
        }
        var subtotalEl = qs("[data-cart-subtotal]");
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        var checkoutBtn = qs("[data-cart-checkout]");
        if (checkoutBtn) checkoutBtn.classList.toggle("btn-disabled", cart.item_count === 0);
        return cart;
      })
      .catch(function () {});
  }

  function showCartBar(message) {
    if (!cartBar) return;
    cartBarMsg.textContent = message;
    cartBar.hidden = false;
    requestAnimationFrame(function () { cartBar.classList.add("active"); });
    setTimeout(function () {
      cartBar.classList.remove("active");
      setTimeout(function () { cartBar.hidden = true; }, 300);
    }, 2600);
  }

  function addToCart(formData, opts) {
    opts = opts || {};
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          showCartBar(res.data.description || "That item couldn't be added.");
          return Promise.reject(res.data);
        }
        return refreshCartDrawer().then(function () {
          if (opts.redirectToCheckout) {
            window.location.href = "/checkout";
          } else {
            openCartDrawer();
          }
        });
      });
  }

    /* Intercept quick-add / product-form submissions for AJAX add-to-cart.
     Matched by action URL (/cart/add) rather than a data attribute, so this
     works for both the homepage quick-add form and the product page form
     without requiring any special markup on either. */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (form.tagName !== "FORM") return;
    var action = form.getAttribute("action") || "";
    if (!/\/cart\/add(\.js)?(\?|#|$)/.test(action)) return;
    e.preventDefault();
    var submitter = e.submitter || document.activeElement;
    var submitBtn = submitter && submitter.matches('[type="submit"]') ? submitter : form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.setAttribute("disabled", "disabled");
    var formData = new FormData(form);
    var redirect = !!(submitter && submitter.hasAttribute("data-buy-now"));
    addToCart(formData, { redirectToCheckout: redirect })
      .catch(function () {})
      .then(function () {
        if (submitBtn) submitBtn.removeAttribute("disabled");
      });
  });

  /* Cart line quantity +/- and remove, inside drawer or cart page */
  document.addEventListener("click", function (e) {
    var incBtn = e.target.closest("[data-qty-increase]");
    var decBtn = e.target.closest("[data-qty-decrease]");
    var removeBtn = e.target.closest("[data-cart-remove]");

    if (incBtn || decBtn) {
      var wrap = (incBtn || decBtn).closest("[data-qty-wrap]");
      var input = wrap.querySelector("[data-qty-input]");
      var val = parseInt(input.value, 10) || 1;
      var lineEl = (incBtn || decBtn).closest("[data-cart-line]");
      var floor = lineEl ? 0 : 1;
      val = incBtn ? val + 1 : Math.max(floor, val - 1);
      input.value = val;
      if (lineEl) {
        changeCartLine(lineEl.getAttribute("data-cart-line"), val);
      } else {
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    if (removeBtn) {
      e.preventDefault();
      var line = removeBtn.closest("[data-cart-line]");
      if (line) changeCartLine(line.getAttribute("data-cart-line"), 0);
    }
  });

  function changeCartLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (cartDrawer && !cartDrawer.hidden) {
          refreshCartDrawer();
        }
        if (document.body.classList.contains("template-cart")) {
          window.location.reload();
        }
      });
  }

  /* Prime cart count on load */
  document.addEventListener("DOMContentLoaded", function () {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
    }).catch(function () {});
  });

  /* ---------------- Product page: variant picker ---------------- */
  qsa("[data-product-form]").forEach(function (root) {
    var dataEl = root.querySelector("[data-product-json]");
    if (!dataEl) return;
    var product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (err) {
      console.error("Kandlelicious: could not parse product JSON — variant picker disabled for this product.", err);
      return;
    }
    if (!product || !product.variants) return;
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector("[data-product-price]");
    var comparePriceEl = root.querySelector("[data-product-compare-price]");
    var skuEl = root.querySelector("[data-product-sku]");
    var availEl = root.querySelector("[data-product-availability]");
    var submitBtn = root.querySelector('[data-add-to-cart]');
    var buyNowBtn = root.querySelector('[data-buy-now-btn]');
    var mainMedia = document.querySelector("[data-pdp-main-media]");
    var thumbs = qsa("[data-pdp-thumb]");

    function getSelectedOptions() {
      var selects = qsa("[data-option-select]", root);
      var swatchGroups = qsa("[data-option-swatch-group]", root);
      var selected = [];
      selects.forEach(function (sel) { selected[parseInt(sel.getAttribute("data-option-index"), 10)] = sel.value; });
      swatchGroups.forEach(function (group) {
        var active = group.querySelector(".kwx-swatch.selected");
        if (active) selected[parseInt(group.getAttribute("data-option-index"), 10)] = active.getAttribute("data-value");
      });
      return selected;
    }

    function findVariant(selected) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < selected.length; j++) {
          if (selected[j] !== undefined && v.options[j] !== selected[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function setMediaByVariant(variant) {
      if (!mainMedia || !variant || !variant.featured_media) return;
      var thumb = thumbs.filter(function (t) { return parseInt(t.getAttribute("data-media-id"), 10) === variant.featured_media.id; })[0];
      if (thumb) thumb.click();
    }

    function updateUI() {
      var selected = getSelectedOptions();
      var variant = findVariant(selected);

      qsa("[data-option-swatch-group]", root).forEach(function (group) {
        var idx = parseInt(group.getAttribute("data-option-index"), 10);
        qsa(".kwx-swatch", group).forEach(function (btn) {
          var testSelected = selected.slice();
          testSelected[idx] = btn.getAttribute("data-value");
          var testVariant = findVariant(testSelected);
          btn.disabled = !testVariant || testVariant.available === false;
        });
      });

      if (!variant) {
        if (submitBtn) { submitBtn.textContent = "Unavailable"; submitBtn.setAttribute("disabled", "disabled"); }
        if (buyNowBtn) buyNowBtn.setAttribute("disabled", "disabled");
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }
      if (skuEl) skuEl.textContent = variant.sku || "—";
      if (availEl) {
        if (variant.available) {
          availEl.textContent = "In stock, ready to ship";
          availEl.className = "kwx-badge-avail in";
        } else {
          availEl.textContent = "Sold out";
          availEl.className = "kwx-badge-avail out";
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? (submitBtn.getAttribute("data-label-add") || "Add to cart") : "Sold out";
      }
      if (buyNowBtn) buyNowBtn.disabled = !variant.available;

      setMediaByVariant(variant);

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        history.replaceState({}, "", url);
      }
    }

    qsa("[data-option-select]", root).forEach(function (sel) { sel.addEventListener("change", updateUI); });
    qsa(".kwx-swatch", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = btn.closest("[data-option-swatch-group]");
        qsa(".kwx-swatch", group).forEach(function (b) { b.classList.remove("selected"); });
        btn.classList.add("selected");
        updateUI();
      });
    });

    updateUI();
  });

  /* Thumbnail gallery */
  qsa("[data-pdp-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var mainMedia = document.querySelector("[data-pdp-main-media]");
      if (!mainMedia) return;
      qsa("[data-pdp-thumb]").forEach(function (t) { t.classList.remove("active"); });
      thumb.classList.add("active");
      mainMedia.innerHTML = '<img src="' + thumb.getAttribute("data-full") + '" alt="' + (thumb.getAttribute("data-alt") || "") + '">';
    });
  });

  /* Cart page: auto-submit on quantity change (progressive enhancement) */
  var cartForm = qs("[data-cart-page-form]");
  if (cartForm) {
    cartForm.addEventListener("change", function (e) {
      if (e.target.matches('input[name^="updates"]')) cartForm.submit();
    });
  }



    /* Featured products: "View more" reveals hidden cards in batches */
  qsa("[data-fp-load-more]").forEach(function (btn) {
    var root = btn.closest(".sec") || document;
    var step = parseInt(btn.getAttribute("data-step"), 10) || 8;
    btn.addEventListener("click", function () {
      var hidden = qsa(".kwx-fp-item.kwx-fp-hidden", root);
      hidden.slice(0, step).forEach(function (el) { el.classList.remove("kwx-fp-hidden"); });
      if (qsa(".kwx-fp-item.kwx-fp-hidden", root).length === 0) {
        btn.hidden = true;
      }
    });
  });



  /* Searchable variant combo — replaces plain <select> for options with many values */
  qsa("[data-combo]").forEach(function (combo) {
    var trigger = combo.querySelector("[data-combo-trigger]");
    var valueEl = combo.querySelector("[data-combo-value]");
    var panel = combo.querySelector("[data-combo-panel]");
    var search = combo.querySelector("[data-combo-search]");
    var list = combo.querySelector("[data-combo-list]");
    var hiddenSelect = combo.querySelector("[data-option-select]");
    var items = qsa("li", list);

    function openPanel() {
      panel.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      search.value = "";
      items.forEach(function (li) { li.hidden = false; });
      var empty = list.querySelector(".kwx-combo-empty");
      if (empty) empty.remove();
      setTimeout(function () { search.focus(); }, 10);
    }
    function closePanel() {
      panel.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
    }

    trigger.addEventListener("click", function () {
      if (panel.hidden) openPanel(); else closePanel();
    });

    search.addEventListener("input", function () {
      var q = search.value.trim().toLowerCase();
      var anyVisible = false;
      items.forEach(function (li) {
        var match = li.textContent.toLowerCase().indexOf(q) !== -1;
        li.hidden = !match;
        if (match) anyVisible = true;
      });
      var empty = list.querySelector(".kwx-combo-empty");
      if (!anyVisible) {
        if (!empty) {
          empty = document.createElement("li");
          empty.className = "kwx-combo-empty";
          empty.textContent = "No matches";
          list.appendChild(empty);
        }
      } else if (empty) {
        empty.remove();
      }
    });

    items.forEach(function (li) {
      li.addEventListener("click", function () {
        items.forEach(function (i) { i.classList.remove("selected"); });
        li.classList.add("selected");
        valueEl.textContent = li.getAttribute("data-value");
        hiddenSelect.value = li.getAttribute("data-value");
        hiddenSelect.dispatchEvent(new Event("change", { bubbles: true }));
        closePanel();
      });
    });

    document.addEventListener("click", function (e) {
      if (!combo.contains(e.target)) closePanel();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !panel.hidden) closePanel();
    });
  });





  /* ---------------- Glow Kit product page (single-select + multi-select combos) ---------------- */
  qsa("[data-glow-kit-form]").forEach(function (form) {
    var variantId = form.getAttribute("data-variant-id");
    var slots = qsa("[data-bb-slot]", form);
    var submitBtn = form.querySelector("[data-bb-submit]");
    var validationEl = form.querySelector("[data-bb-validation]");
    var selections = {};

    function isMulti(slot) { return !!slot.getAttribute("data-bb-multi"); }
    function maxCount(slot) { return parseInt(slot.getAttribute("data-bb-multi"), 10) || 1; }

    function formatSelection(arr) {
      if (!arr || arr.length === 0) return "";
      var counts = {};
      var order = [];
      arr.forEach(function (t) {
        if (!counts[t]) order.push(t);
        counts[t] = (counts[t] || 0) + 1;
      });
      return order.map(function (t) {
        return counts[t] > 1 ? (t + " (x" + counts[t] + ")") : t;
      }).join(", ");
    }

    function updateSubmitState() {
      var allFilled = slots.every(function (s) {
        var key = s.getAttribute("data-bb-slot");
        if (isMulti(s)) {
          var arr = selections[key] || [];
          return arr.length === maxCount(s);
        }
        return !!selections[key];
      });
      submitBtn.disabled = !allFilled;
      return allFilled;
    }

    slots.forEach(function (slot) {
      var key = slot.getAttribute("data-bb-slot");
      var multi = isMulti(slot);
      var max = maxCount(slot);
      var combo = slot.querySelector("[data-bb-combo]");
      if (!combo) return;
      var trigger = combo.querySelector("[data-bb-trigger]");
      var triggerValue = combo.querySelector("[data-bb-trigger-value]");
      var panel = combo.querySelector("[data-bb-panel]");
      var search = combo.querySelector("[data-bb-search]");
      var list = combo.querySelector("[data-bb-list]");
      var items = qsa("[data-bb-option]", list);
      var availableCount = items.filter(function (li) { return !li.hasAttribute("data-unavailable"); }).length;

      if (multi) selections[key] = [];

      function updateTriggerLabel() {
        if (!multi) return;
        var arr = selections[key] || [];
        if (arr.length === 0) {
          triggerValue.textContent = "Select two scents";
          trigger.classList.remove("kwx-combo-filled");
        } else {
          triggerValue.textContent = formatSelection(arr);
          trigger.classList.toggle("kwx-combo-filled", arr.length === max);
        }
      }

      function openPanel() {
        qsa("[data-bb-panel]", form).forEach(function (p) { if (p !== panel) p.hidden = true; });
        panel.hidden = false;
        trigger.setAttribute("aria-expanded", "true");
        search.value = "";
        items.forEach(function (li) { li.hidden = false; });
        setTimeout(function () { search.focus(); }, 10);
      }
      function closePanel() {
        panel.hidden = true;
        trigger.setAttribute("aria-expanded", "false");
      }

      trigger.addEventListener("click", function (e) {
        e.stopPropagation();
        if (panel.hidden) openPanel(); else closePanel();
      });

      search.addEventListener("input", function () {
        var q = search.value.trim().toLowerCase();
        items.forEach(function (li) {
          li.hidden = li.textContent.toLowerCase().indexOf(q) === -1;
        });
      });

      items.forEach(function (li) {
        li.addEventListener("click", function () {
          if (li.hasAttribute("data-unavailable")) return;
          var title = li.getAttribute("data-title");

          if (multi) {
            var arr = selections[key] || [];
            if (arr.length >= max) return;
            arr.push(title);
            /* Only one product exists in this collection — a single click
               fills every remaining slot with it automatically. */
            if (availableCount === 1) {
              while (arr.length < max) arr.push(title);
            }
            selections[key] = arr;
            li.classList.add("selected");
            updateTriggerLabel();
            updateSubmitState();
            if (arr.length >= max) closePanel();
          } else {
            qsa("[data-bb-option]", list).forEach(function (o) { o.classList.remove("selected"); });
            li.classList.add("selected");
            selections[key] = title;
            triggerValue.textContent = title;
            trigger.classList.add("kwx-combo-filled");
            updateSubmitState();
            closePanel();
          }
        });
      });
    });

    document.addEventListener("click", function (e) {
      qsa("[data-bb-combo]", form).forEach(function (combo) {
        if (!combo.contains(e.target)) {
          var panel = combo.querySelector("[data-bb-panel]");
          var trigger = combo.querySelector("[data-bb-trigger]");
          panel.hidden = true;
          trigger.setAttribute("aria-expanded", "false");
        }
      });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!updateSubmitState()) return;

      var properties = {};
      slots.forEach(function (slot) {
        var key = slot.getAttribute("data-bb-slot");
        var label = slot.getAttribute("data-bb-label");
        var val = selections[key];
        properties[label] = Array.isArray(val) ? formatSelection(val) : val;
      });

      submitBtn.disabled = true;
      var originalLabel = submitBtn.textContent;
      submitBtn.textContent = "Adding…";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1, properties: properties }]
        })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          submitBtn.textContent = originalLabel;
          submitBtn.disabled = false;
          if (!res.ok) {
            validationEl.textContent = (res.data && res.data.description) || "Something went wrong. Please try again.";
            validationEl.hidden = false;
            return;
          }
          fetch("/cart.js")
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              qsa("[data-cart-count]").forEach(function (el) {
                el.textContent = cart.item_count;
                el.hidden = cart.item_count === 0;
              });
            })
            .catch(function () {});

          var drawerToggle = document.querySelector("[data-cart-drawer-toggle]");
          if (drawerToggle) { drawerToggle.click(); } else { window.location.href = "/cart"; }
        })
        .catch(function () {
          validationEl.textContent = "Network error — please try again.";
          validationEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
        });
    });

    updateSubmitState();
  });



})();